import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { datricApi } from '../../../services/api/datric.api';
import { CreateIndicatorPayload, Indicator, UpdateIndicatorPayload } from '../../../models/indicator.model';
import { toastService } from '../../../services/toast.service';

export interface IndicatorState {
	list: Indicator[];
	loading: boolean;
}

const initialState: IndicatorState = {
	list: [],
	loading: false
};

export const fetchIndicators = createAsyncThunk('indicator/list', async () => {
	return datricApi.indicator.list();
});

export const createIndicator = createAsyncThunk(
	'indicator/create',
	async (payload: CreateIndicatorPayload, { dispatch, rejectWithValue }) => {
		try {
			const res = await datricApi.indicator.create(payload);
			toastService.success('Indicador criado');
			dispatch(fetchIndicators());
			return res;
		} catch (e: any) {
			toastService.error(typeof e === 'string' ? e : 'Falha ao criar indicador');
			return rejectWithValue(e);
		}
	}
);

export const editIndicator = createAsyncThunk(
	'indicator/edit',
	async (payload: { id: string } & UpdateIndicatorPayload, { dispatch, rejectWithValue }) => {
		try {
			const { id, ...data } = payload;
			const res = await datricApi.indicator.update(id, data);
			toastService.success('Indicador atualizado');
			dispatch(fetchIndicators());
			return res;
		} catch (e: any) {
			toastService.error(typeof e === 'string' ? e : 'Falha ao atualizar indicador');
			return rejectWithValue(e);
		}
	}
);

export const toggleIndicatorActive = createAsyncThunk(
	'indicator/toggleActive',
	async (payload: { id: string; active: boolean }, { dispatch, rejectWithValue }) => {
		try {
			const res = await datricApi.indicator.setActive(payload.id, payload.active);
			dispatch(fetchIndicators());
			return res;
		} catch (e: any) {
			toastService.error(typeof e === 'string' ? e : 'Falha ao alterar status');
			return rejectWithValue(e);
		}
	}
);

export const removeIndicator = createAsyncThunk(
	'indicator/remove',
	async (payload: { id: string }, { dispatch, rejectWithValue }) => {
		try {
			const res = await datricApi.indicator.delete(payload.id);
			toastService.success('Indicador excluído');
			dispatch(fetchIndicators());
			return res;
		} catch (e: any) {
			toastService.error(typeof e === 'string' ? e : 'Falha ao excluir indicador');
			return rejectWithValue(e);
		}
	}
);

export const indicatorSlice = createSlice({
	name: 'indicator',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(fetchIndicators.pending, state => {
			state.loading = true;
		});
		builder.addCase(fetchIndicators.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload as Indicator[];
		});
		builder.addCase(fetchIndicators.rejected, state => {
			state.loading = false;
		});
	}
});
